import { AppBar, Grid } from "@mui/material";
import { Link } from "react-router-dom";

const TopBar = () => {
  return (
    <AppBar position="fixed" elevation={0}>
      <Grid
        container
        sx={{
          height: "48px",
          background: "#050D2E",
          color: "white",
        }}
        px={2}
        justifyContent="space-between"
        alignItems="center"
      >
        <Grid item>
          <Link to="/" style={{ textDecoration: "none", color: "white" }}>
            CORZAP
          </Link>
        </Grid>
      </Grid>
    </AppBar>
  );
};

export default TopBar;
